module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAwUlEQVQokZ2TTQrCMBBGn72AP1v3goLHsEJPoZ5CPIG30FMUrMcQFLrWrdoLNPJhBuLC0uZBVvleMiQzPeccAQmwAJbAHBgCL+ACnIAzUFs8lMfAHpjynxuwBR6hLPEAjBpE4wmsdYBklXoEZi1E4wqsJKYdRXw+lZx1FI0sibjVmEgeRMp9ye9IuUr8y8VQSs4j5VxyEXG78oVk9erOd04blFO+lizuwMb3bhPaV075n8EQ4VRpQPSNlZXp13eqgA9NxjQT9vw7sQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/mobile/white_radio.png
// module id = QDT1
// module chunks = 1